import { useEffect, useLayoutEffect } from "react";
const isWeb = process.env.TAMAGUI_TARGET === "web";
const isWindowDefined = typeof window !== "undefined";
const isServer = isWeb && !isWindowDefined;
const isClient = isWeb && isWindowDefined;
const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;
const isChrome = typeof navigator !== "undefined" && /Chrome/.test(navigator.userAgent || "");
const isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const isTouchable = !isWeb || isWebTouchable;
const isAndroid = false;
const isIos = false;
const currentPlatform = "web";
if (!process.env.TAMAGUI_TARGET) {
  console.warn(`\u26A0\uFE0F Must set TAMAGUI_TARGET (set TAMAGUI_SHOW_TRACE=1 to see trace)`);
  if (process.env.TAMAGUI_SHOW_TRACE) {
    console.trace();
  }
}
if (process.env.NODE_ENV === "development") {
  if (isClient && process.env.TAMAGUI_TARGET !== "web" && process.env.TAMAGUI_IGNORE_TARGET !== "1") {
    console.warn(
      `Must set TAMAGUI_TARGET to "web" for web apps - if you have window defined outside of the browser, set TAMAGUI_IGNORE_TARGET=1 to hide this`
    );
  }
}
export {
  currentPlatform,
  isAndroid,
  isChrome,
  isClient,
  isIos,
  isServer,
  isTouchable,
  isWeb,
  isWebTouchable,
  isWindowDefined,
  useIsomorphicLayoutEffect
};
//# sourceMappingURL=index.js.map
